import { toast } from "react-toastify";

export default function ReferralSummary({ user }) {
  const referralLink = user?.referralCode
    ? `${window.location.origin}/ref/${user.referralCode}`
    : "";

  const handleCopy = async () => {
    if (!referralLink) return;
    await navigator.clipboard.writeText(referralLink);
    toast.success("Referral link copied!");
  };

  const handleShare = async () => {
    if (!referralLink) return;

    try {
      if (navigator.share) {
        await navigator.share({
          title: "Join ShareVideo",
          text: "Earn coins using my referral link!",
          url: referralLink,
        });
      } else {
        await navigator.clipboard.writeText(referralLink);
        toast.success("Referral link copied!");
      }
    } catch (err) {
      console.log("Share failed", err);
    }
  };

  return (
    <div className="profile-card">
      <h3>Refer & Earn</h3>

      <p>
        <strong>Your Referral Code:</strong>
        <br />
        {user?.referralCode}
      </p>

      <input
        value={referralLink}
        readOnly
        style={{
          width: "100%",
          padding: 8,
          marginBottom: 10,
          borderRadius: 6,
          border: "1px solid #ddd",
        }}
      />

      <div style={{ display: "flex", gap: 10 }}>
        <button
          style={{ flex: 1 }}
          className="primary-btn"
          onClick={handleCopy}
        >
          Copy
        </button>

        <button
          style={{ flex: 1 }}
          className="primary-btn"
          onClick={handleShare}
        >
          Refer Now
        </button>
      </div>
    </div>
  );
}
